// Field.tsx
import React from "react";

interface FieldProps {
  label: string;
  hint?: string;
  children: React.ReactNode;
}

export default function Field({ label, hint, children }: FieldProps) {
  return (
    <div>
      <label className="text-sm font-medium text-gray-800">{label}</label>
      <div className="mt-1">{children}</div>
      {hint && <p className="text-xs text-gray-400 mt-1">{hint}</p>}
    </div>
  );
}
